<!--begin::Page Heading-->
<ng-container *ngIf="title$ | async as _title">
  <h2 class="text-dark font-weight-bold my-1 mr-5" style="margin: 0; line-height: 65px;">
    {{ _title }}
  </h2>
</ng-container>
<!--<div class="d-flex align-items-baseline flex-wrap mr-5">
  &lt;!&ndash;begin::Breadcrumb&ndash;&gt;
  <ul
    class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2 font-size-sm"
  >
    <li
      class="breadcrumb-item" style="line-height: 60px;"
      *ngFor="let bc of breadcrumbs"
      routerLinkActive="active"
    >
      <a [routerLink]="bc.linkPath" class="text-muted">
        {{ bc.linkText }}
      </a>
    </li>
  </ul>
  &lt;!&ndash;end::Breadcrumb&ndash;&gt;
</div>-->
